import styled from "@emotion/styled";

export const Dot = styled.div`
  min-height: var(--size);
  min-width: var(--size);
  max-width: var(--size);
  max-height: var(--size);
  margin-right: var(--size);
  background-color: var(--dotColor);
  border-radius: 99px;
`;
